import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-6 pb-8 sm:pt-12 sm:pb-20 items-center justify-center bg-bg-main overflow-hidden" data-id="element-135">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/20 rounded-full blur-[120px] pointer-events-none" data-id="element-136"></div>

      {/* Attention Badge */}
      <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="relative bg-badge-red/10 border border-badge-red/20 text-badge-red font-bold text-[10px] sm:text-xs px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6 flex items-center gap-1.5 sm:gap-2 shadow-[0_0_15px_rgba(239,68,68,0.15)]" data-id="element-137">
        <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-badge-red animate-pulse shadow-[0_0_8px_rgba(239,68,68,0.8)]" data-id="element-138"></span>
        <span className="hidden sm:inline" data-id="element-139">
          🧘‍♀️ ATENCIÓN: INSTRUCTORAS DE PILATES CANSADAS DE SACRIFICAR SUS NOCHES
          PLANIFICANDO
        </span>
        <span className="sm:hidden" data-id="element-140">ATENCIÓN: INSTRUCTORAS DE PILATES</span>
      </motion.div>

      {/* Main headline */}
      <motion.h1 initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.1
    }} className="relative font-black text-text-main max-w-5xl text-[26px] leading-[1.15] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-4 sm:mb-6 tracking-tight" data-id="element-141">
        Deja de ser una esclava de la planificación y{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-blue-400" data-id="element-142">
          recupera 10 horas de tu semana.
        </span>
      </motion.h1>

      {/* Subheadline — compact on mobile */}
      <motion.p initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2
    }} className="relative text-text-sec text-sm sm:text-xl font-medium leading-relaxed mb-4 sm:mb-8 max-w-3xl mx-auto sm:bg-white/5 sm:backdrop-blur-sm sm:border sm:border-white/10 sm:border-l-4 sm:border-l-primary sm:px-8 sm:py-5 sm:rounded-r-xl sm:shadow-2xl sm:text-left" data-id="element-143">
        El único Sistema Visual{' '}
        <span className="text-primary font-bold" data-id="element-144">"Abrir y Dictar"</span> que
        resuelve tu año completo de Pilates en 5 minutos.{' '}
        <span className="hidden sm:inline text-text-main font-semibold" data-id="element-145">
          Sin improvisar, sin estrés y sin hojas en blanco.
        </span>
      </motion.p>

      {/* Mockup image */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.3,
      type: 'spring'
    }} className="relative w-full max-w-[240px] sm:max-w-[380px] md:max-w-[460px] mx-auto mb-4 sm:mb-8" data-id="element-146">
        <div className="absolute inset-0 bg-primary/20 blur-[60px] rounded-full" data-id="element-147"></div>
        <img src="https://cdn.magicpatterns.com/uploads/3z9Ukib7CkgwKkSMdv39BR/Diseno_sin_titulo_(24).png" alt="EDULABS MegaPack Pilates Listo — Combo Completo" className="relative w-full h-auto object-contain drop-shadow-[0_20px_50px_rgba(0,0,0,0.5)]" width={500} height={500} fetchPriority="high" data-id="element-148" />
      </motion.div>

      {/* Stars + Urgency */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.4
    }} className="relative flex flex-col items-center gap-2 sm:gap-2 mb-4 sm:mb-6" data-id="element-149">
        <div className="flex items-center gap-2" data-id="element-150">
          <span className="text-secondary text-sm sm:text-lg drop-shadow-[0_0_8px_rgba(245,158,11,0.5)]" data-id="element-151">
            ⭐⭐⭐⭐⭐
          </span>
          <span className="text-text-sec text-xs sm:text-base font-medium" data-id="element-152">
            4.9/5 (+500 Verificados)
          </span>
        </div>
        <span className="text-secondary font-bold text-xs sm:text-sm bg-secondary/10 px-3 py-1 rounded-full border border-secondary/20" data-id="element-153">
          🔥 47 instructoras compraron hoy
        </span>
      </motion.div>

      {/* CTA Button */}
      <motion.a initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.5
    }} href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-base sm:text-2xl px-6 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-154">
        🚀 ¡SÍ! DAME MI TIEMPO DE VUELTA
      </motion.a>

      {/* Trust badges */}
      <motion.p initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.6
    }} className="relative text-text-sec text-[11px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-2 flex-wrap" data-id="element-155">
        <span data-id="element-156">⚡ Acceso Inmediato</span>
        <span data-id="element-157">•</span>
        <span data-id="element-158">🛡️ Garantía 7 Días</span>
        <span data-id="element-159">•</span>
        <span data-id="element-160">💳 Pago Único</span>
      </motion.p>
    </section>;
}